export const TimespanType_Second = 'second';
export const TimespanType_Minute = 'minute';
export const TimespanType_Hour = 'hour';
export const TimespanType_Day = 'day';
export const TimespanType_Week = 'week';
export const TimespanType_Month = 'month';
export const TimespanType_Year = 'year';
export const TimespansType = [TimespanType_Second,
    TimespanType_Minute,
    TimespanType_Hour,
    TimespanType_Day,
    TimespanType_Week,
    TimespanType_Month,
    TimespanType_Year
];
//# sourceMappingURL=types.js.map